import SuccessPage from './SuccessPage';
export type { SuccessPageProps } from './SuccessPage.types';

export default SuccessPage;
